//  @/store/modules/promos.js
import Vue from 'vue'

const state = {    
    headers: [
        {
            text: 'Fournisseur',
            value: 'vendor',
        },
        {
            text: 'Promotion',
            value: 'name',
        },
        {
            text: 'Code promo',
            value: 'code',
        },
        {
            text: 'Entrée en vigueur',
            value: 'effectiveDate',
        },
        {
            text: 'Expiration',
            value: 'expiryDate',
        },
        {
            text: 'Modèle',
            value: 'model',
            values: ['Model', 'model'],
        },
        {
            text: 'ACCESSORIES',
            value: 'accessories',
            values: ['Accessories'],
        },
        {
            text: 'SKU',
            value: 'sku',
            values: ['Item Code', 'Item Number', 'Sku', 'sku'],
        },
        {
            text: 'Quantité',
            value: 'qty',
            values: ['Quantity'],
        },
        {
          text: 'Rabais',
          value: 'rebate',
          values: ['Rebate', 'Rabais']
        },
        {
            text: 'Prix consenti',
            value: 'price',
            values: ['Approved', 'Discount'],
        },
        {
            text: 'Extension de promotion',
            value: 'extended',
            values: ['Extended Approved'],
        },
        {
            text: 'Accessoires',
            value: 'accessories',
            values: ['Accessories', 'Accessoires'],
        },
        {
            text: 'Ristourne',
            value: 'payBack',
            values: ['Ristourne'],
        },
    ],
    items: [],
  }
  
  const mutations = {
    SET_LISTENER (state, listener) {
      state.listener = listener
    },
    SET_ITEM (state, doc) {
      const data = doc.data()
      state.items = {
        ...state.items, 
        [doc.id]: data
      }
    },
    UPDATE_ITEM (state, doc) {
      state.items[doc.id] = doc.data()
    },
    DELETE_ITEM (state, doc) {
      Vue.delete(state.items, doc.id)
    },
  }

  const getters = {}
  
  const actions = {
    async init({ commit, state, rootState }) {
      commit('SET_LISTENER', 
      rootState.db.collection('promos').onSnapshot(snapshot => {
        let changes = snapshot.docChanges()
        changes.forEach(change => {
          let type = change.type
          let doc = change.doc
          
          if(type === 'added') commit('SET_ITEM', doc)
          else if(type === 'modified') commit('UPDATE_ITEM', doc)
          else if(type === 'removed') commit('DELETE_ITEM', doc)
        })
      }, (error) => {console.log(error.message)}))
    },
    async add({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data.updates = [ update ]

      let response = await rootState.db.collection('promos').add(data)
      return response
    },
    async set({ rootState, dispatch }, data) {
      let response = ''
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      if(!Boolean(data[0])) response = dispatch('add', data[1])
      else {
        data[1].updates = [ ...data[1].updates, update ]
  
        let ref = rootState.db.collection('promos').doc(data[0])
        response = await ref.set(data[1])
      }

      return response
    },
    async delete({ rootState }, id) {
      let response = await rootState.db.collection('promos').doc(id).delete()
      return response
    },
    deleteBatch({ commit, rootState }, documents) {
      let batches = []
      let i = 0
  
      documents.forEach(document => {
        if(!Boolean(batches[i])) batches[i] = []
        
        if(batches[i].length < 499) batches[i].push(document)
        else {
          i++
          batches[i] = []
          batches[i].push(document)
        }
      })

      batches.forEach(b => {
        let batch = rootState.db.batch()
        b.forEach(document => {
          let ref = rootState.db.collection('promos').doc(document)
          return batch.delete(ref)
        })
  
        batch.commit()
          .then(() => { setTimeout(() => { return }, 1000) })
          .catch(err => { console.log(err.message) })
      })
    },
    async close({ rootState }) { 
      let response = await rootState.db.collection('promos').onSnapshot(() => {})
      return response
    },
  }
  
  export default { 
    namespaced: true, state, mutations, getters, actions
  }